import { t } from '@framework/i18n';
import { yup } from '@framework/validation';
import dayjs from 'dayjs';
import { RuleType } from '../../IRule';
import { IRuleType } from '../../IRuleType';
import { DateRangeRuleComponent } from './DateRangeRuleComponent';

// TODO usare le stringDate() quando ci sarà il package
const configValidator = yup
  .object({
    fromDate: yup.string().notRequired().label('data inizio'),
    toDate: yup
      .string()
      .notRequired()
      .label('data fine')
      .isAfter(
        'fromDate',
        'La ${label} deve essere successiva alla data inizio',
      ),
    minCustomMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
    maxCustomMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown();

export type IDateRangeRuleOptions = yup.InferType<typeof configValidator>;

export const DateRangeRule: IRuleType<IDateRangeRuleOptions> = {
  type: RuleType.DateRange,
  name: 'Intervallo di date',
  configComponent: DateRangeRuleComponent,
  configValidator: configValidator,
  validator: (schema, rule) => {
    if (!rule) return schema;

    const { fromDate, toDate } = rule;

    if (!fromDate && !toDate) return schema;

    schema = schema.test({
      name: 'date-range',
      exclusive: false,
      params: { fromDate, toDate },
      skipAbsent: true,
      test: function (value, context) {
        if (fromDate && dayjs(value).isBefore(dayjs(fromDate))) {
          return context.createError({
            message:
              rule.minCustomMessage ??
              t(
                'rules.date-range.min-date',
                'La data deve essere successiva al {{from_date}}',
                { from_date: dayjs(fromDate).format('DD/MM/YYYY') },
              ),
          });
        }

        if (toDate && dayjs(value).isAfter(dayjs(toDate))) {
          return context.createError({
            message:
              rule.maxCustomMessage ??
              t(
                'rules.date-range.max-date',
                'La data deve essere precedente al {{to_date}}',
                { to_date: dayjs(toDate).format('DD/MM/YYYY') },
              ),
          });
        }

        return true;
      },
    });
    return schema;
  },
};
